import { Lock, Upload } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ReadOnlyBannerProps {
  className?: string;
}

export function ReadOnlyBanner({ className }: ReadOnlyBannerProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-3 rounded-lg border border-teal-200 bg-teal-50 px-4 py-3 text-sm dark:border-teal-800 dark:bg-teal-950',
        className
      )}
    >
      <Lock className="h-4 w-4 shrink-0 text-teal-600 dark:text-teal-400" />
      <span className="text-teal-700 dark:text-teal-300">
        This policy is approved and locked. To make changes, upload a new version.
      </span>
      <Upload className="h-4 w-4 shrink-0 text-teal-600 dark:text-teal-400 ml-auto" />
    </div>
  );
}
